import { useEffect, useRef } from "react";

import { Select } from "antd";

import { useSurveyDataSources } from "./hooks/useSurveyDataSources";

interface Props {
  value?: string;
  onChange?: (value: string) => void;
}

export function PrimarySourceSelect({ value, onChange }: Props) {
  const sources = useSurveyDataSources();
  const hasAutoSelected = useRef(false);

  useEffect(() => {
    if (!value && !hasAutoSelected.current && sources.length > 0 && onChange) {
      const firstActive = sources.find((s) => s.isActive);
      if (firstActive) {
        hasAutoSelected.current = true;
        onChange(firstActive.sourceDb);
      }
    }
  }, [value, sources, onChange]);

  const options = sources.map((s) => ({
    label: s.isActive
      ? s.dataSourceDisplayName ?? s.dataSourceName
      : `${s.dataSourceDisplayName ?? s.dataSourceName} (inactive)`,
    value: s.sourceDb
  }));

  return (
    <Select
      data-testid="primary-source-select"
      value={value}
      options={options}
      onChange={onChange}
    />
  );
}
